import { render } from "./CredentialsDetails.vue?vue&type=template&id=5f0cc7c0&scoped=true"
import script from "./CredentialsDetails.vue?vue&type=script&lang=js"
export * from "./CredentialsDetails.vue?vue&type=script&lang=js"

import "./CredentialsDetails.vue?vue&type=style&index=0&id=5f0cc7c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0cc7c0"]])

export default __exports__